import Vue from "vue";
import { Button, ButtonGroup, Modal, Tag, Spin, Input, Form, FormItem, Card, Switch, Icon, Menu, Sider, MenuItem, Submenu, Content, Layout, Row, Col, Header, Split, Divider } from "view-design";

Vue.component("Button", Button); // TODO: migrate
Vue.component("i-button", Button);
Vue.component("i-button-group", ButtonGroup);
Vue.component("i-modal", Modal);
Vue.component("i-tag", Tag);
Vue.component("i-spin", Spin);
Vue.component("i-input", Input);
Vue.component("i-form", Form);
Vue.component("i-form-item", FormItem);
Vue.component("i-card", Card);
Vue.component("i-switch", Switch);
Vue.component("i-icon", Icon);
Vue.component("i-sider", Sider);
Vue.component("i-menu-item", MenuItem);
Vue.component("i-menu", Menu);
Vue.component("i-sub-menu", Submenu);
Vue.component("i-content", Content);
Vue.component("i-layout", Layout);
Vue.component("i-row", Row);
Vue.component("i-col", Col);
Vue.component("i-header", Header);
Vue.component("i-split", Split);
Vue.component("i-divider", Divider);

// import 'view-design/dist/styles/view-design.css'
